
<opac-button *ngIf="showButton() && !disabled" type="text" (click)="load.emit()">
  {{ 'general.viewMore' | translate }}
</opac-button>